import React, { useState } from "react";
import NavbarPromoCode from "../Layouts/NavbarPromoCode";
import PromoCodeSidebar from "../Layouts/PromoCodeSidebar";
import "../Views/promoCode.css";
import { Outlet } from "react-router-dom";
import { PromoCodeAlert } from "../Components/PromoCodeAlert";
import { PromoAlertData } from "../../Helper";

interface MainPromoCodeProps {
  promoAlert: PromoAlertData;
  setPromoAlert: (data: PromoAlertData) => void;
}

const MainPromoCode = ({ promoAlert, setPromoAlert }: MainPromoCodeProps) => {
  return (
    <>
      <div className="conatiner-fluid h-100">
        <NavbarPromoCode />
        <div className={`d-flex no-gutters`}>
          <div className="sidebar-layout">
            <PromoCodeSidebar />
          </div>
          <div className="flex-grow-1 promo-code-body">
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

export default MainPromoCode;
